import { useQuery } from '@tanstack/react-query';

import getGiveawayStatuses from 'Api/brief-live/getGiveawayStatuses';

import getGiveawayStatusesResponse from './model/response/getGiveawayStatusesResponse';

const useGetGiveawayStatuses = () => {
  return useQuery({
    queryKey: ['all-giveaway-statuses'],
    queryFn: async () => {
      const response = await getGiveawayStatuses();

      const result = getGiveawayStatusesResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export default useGetGiveawayStatuses;
